class StickyImageCards extends HTMLElement {
  connectedCallback() {
    setTimeout(() => this._init());
  }

  _init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this._groups = Array.from(this.querySelectorAll('.card-group'));
    this._medias = Array.from(this.querySelectorAll('.card-media'));
    this._contents = Array.from(this.querySelectorAll('.card-content'));

    if (this._groups.length < 2) return;

    this._rafId = null;
    this._isMobile = window.matchMedia('(max-width: 749px)').matches;
    this._cacheLayout();

    this._onScroll = () => {
      if (this._rafId) return;
      this._rafId = requestAnimationFrame(() => {
        this._rafId = null;
        this._update();
      });
    };

    this._onResize = () => {
      this._isMobile = window.matchMedia('(max-width: 749px)').matches;
      this._cacheLayout();
      this._update();
    };

    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    this._update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onResize);
    if (this._rafId) cancelAnimationFrame(this._rafId);
  }

  // 缓存不随滚动变化的值，仅在 resize 时重新计算
  _cacheLayout() {
    // 手机端 sticky 元素是 .card-group，桌面端是 .card-media
    const stickyEl = this._isMobile ? this._groups[0] : this._medias[0];
    this._stickyTop = parseFloat(getComputedStyle(stickyEl).top) || 80;
    // 手机端：缓存每个 group 的高度，用于计算动画范围
    this._groupHeights = this._groups.map((g) => g.offsetHeight);
    // 桌面端
    this._desktopStartY = window.innerHeight * 0.85;
    this._desktopRange = Math.max(1, this._desktopStartY - this._stickyTop);
  }

  _update() {
    if (this._isMobile) {
      // 清除桌面端残留
      for (const m of this._medias) m.style.removeProperty('--past-progress');
      this._applyMobile();
    } else {
      // 清除手机端残留
      for (const g of this._groups) g.style.removeProperty('--past-progress');
      this._applyDesktop();
    }
  }

  _applyMobile() {
    const { _stickyTop: stickyTop } = this;
    const n = this._groups.length;

    // 批量读取（避免读写交替导致强制 reflow）
    const groupTops = this._groups.map((g) => g.getBoundingClientRect().top);

    // 批量写入
    for (let i = 0; i < n - 1; i++) {
      const range = Math.max(1, this._groupHeights[i]);
      // 动画进度由下一个 group 距 stickyTop 的距离驱动
      // nextTop = stickyTop + range → progress = 0（尚未开始）
      // nextTop = stickyTop        → progress = 1（下一张已完全到达顶部）
      const progress = Math.max(0, Math.min(1, (stickyTop + range - groupTops[i + 1]) / range));
      if (progress === 0) {
        this._groups[i].style.removeProperty('--past-progress');
      } else {
        this._groups[i].style.setProperty('--past-progress', progress);
      }
    }
    // 最后一张不退出
    this._groups[n - 1].style.removeProperty('--past-progress');
  }

  _applyDesktop() {
    const { _desktopStartY: startY, _desktopRange: range } = this;

    // 批量读取
    const tops = this._contents.map((c) => c.getBoundingClientRect().top);

    // 批量写入
    for (let i = 1; i < this._contents.length; i++) {
      const progress = Math.max(0, Math.min(1, (startY - tops[i]) / range));
      this._medias[i - 1].style.setProperty('--past-progress', progress);
    }
  }
}

customElements.define('sticky-image-cards', StickyImageCards);
